import ImagePreloader from "./ImagePreloader";
import Vue from 'vue'
import UnexLib from "./UnexLib";
import { application } from "./application.js"
import $ from 'jquery'

export class query {

    constructor(App) {
        /** @type {application} */
        this.App = App

        // globals
        this.current_query = null;
        this.is_new_query = true;
        this.current_category_filter_selected = '';
        this.applications_solutions_group = [];

        // Filters
        this.active_filters = {};
        this.total_works = 0;
        this.total_solutions = 0;
        this.valid_keys = {
            products: "product_families",
            materials: "materials",
            assemblies: "assemblies",
            interior: "interior",
            sectors: "sectors",
            applications: "applications",
            themes: "themes",
            countries: "countries"
        };

        // Solutions
        this.active_search = [];
    }

    init() {
        // Force query filters
        this.clean()
    }

    /**
     * Reset filters
     */
    clean() {
        this.runFiltersQuery([]);
    }


    /**
     * Consulta el servidor canviant els filtres
     *
     * @param {*} data
     * @returns
     */
    async runFiltersQuery(data) {
        // TODO: revisar
        this.updateFilterHistory(data);

        // Check keys (some names are wrong)
        var valid_keys = {
            products: "product_families",
            materials: "materials",
            assemblies: "assemblies",
            interior: "interior",
            sectors: "sectors",
            applications: "applications",
            themes: "themes",
            countries: "countries"
        };
        var valid_data = {};    // {data} processed for erroneous keys

        for (const [key, value] of Object.entries(valid_keys)) {
            var key_name = key; // valid_keys[key];         // TODO: remove si segueix funcionant bé
            if (typeof (data[key_name]) !== "undefined" && Array.isArray(data[key_name])) {
                valid_data[key_name] = data[key_name];
            }
        }


        valid_data.language = this.App.selected_language_solutions;
        valid_data.market = this.App.selected_market_solutions;

        //////////////////// DO query
        var filters = await this.App.api.post(
            "/filters",
            valid_data,
            {
                // Authorization: obj.bearer
            });

        this.total_works = filters.total_works
        this.total_solutions = filters.total_solutions

        //////////////////// Processar resultat
        var results = {};

        for (var filter_key in valid_keys) {
            var filter_name = filter_key
            var valid_filter_key = valid_keys[filter_key]
            var results_for_filter = {};

            var values_for_key = this.App.entities[valid_filter_key]

            for (var fkey in values_for_key) {
                if (filter_name != 'interior' && (fkey === 0 || fkey === "0")) continue;

                results_for_filter[fkey] = {};
                results_for_filter[fkey]['text'] = values_for_key[fkey][this.App.selected_language_solutions];  // TODO: fer millor...
                results_for_filter[fkey]['has_results'] =
                    (filters[filter_name].indexOf(parseInt(fkey)) !== -1 || filters[filter_name].indexOf(fkey.toString()) !== -1) ? true : false;
                results_for_filter[fkey]['selected'] =
                    valid_data[filter_name] !== undefined
                    && (valid_data[filter_name].indexOf(parseInt(fkey)) !== -1
                        || valid_data[filter_name].indexOf(fkey) !== -1);
            }


            // Canviar nom de la clau
            results[valid_filter_key] = this.orderedText(results_for_filter);
            // results[valid_filter_key] = results_for_filter;
        }

        // TODO: Ordenar
        // this.orderedText(results)

        this.active_filters = results;

        return this.active_filters;

    }

    /**
     * Consulta el servidor les solucions que compleixen els filtres
     *
     * @param {*} filters
     * @param {*} on_load
     * @returns
     */
    async runSolutionsQuery(filters, on_load) {
        var valid_keys = ["interior", "sectors", "applications", "themes", "assemblies", "products", "materials", "countries"];
        var valid_data = {};
        for (var key in valid_keys) {
            var key_name = valid_keys[key];
            if (typeof (filters[key_name]) !== "undefined" && Array.isArray(filters[key_name])) {
                valid_data[key_name] = filters[key_name];
            }
        }
        valid_data.language = this.App.selected_language_solutions;
        valid_data.market = this.App.selected_market_solutions;

        if (filters.order_by !== undefined) {
            valid_data.order_by = filters.order_by;
            if (filters.order_by_type !== undefined) {
                valid_data.order_by_type = filters.order_by_type;
            }
        }

        //////////////////// DO query
        var solutions = await this.App.api.post(
            "/search",
            valid_data,
            {
                // Authorization: obj.bearer
            });


        this.active_search = solutions['data']
        return;

    }

    /**
     * Gets the number of elements selected for a given filterName
     *
     * @param {String} filterGroup
     * @returns
     */
    getTotalSelectedForFilterGroup(filterGroup) {
        var total_filters_selected = 0;

        for (var key in this.active_filters[filterGroup]) {
            if (this.active_filters[filterGroup][key].selected == true && key != 'count_active') {
                total_filters_selected++;
            }
        }
        return total_filters_selected;
    }

    /**
     * Gets the total number of filters applied
     * @returns int
     */
    getTotalSelected() {
        var total = 0

        for (var filterName in this.active_filters) {
            total += this.getTotalSelectedForFilterGroup(filterName)
        }
        return total;
    }
    /**
     * Gets the total elements for a given filterName
     * @param {String} filterGroup
     * @returns
     */
    getTotalForFilterGroup(filterGroup) {
        return Object.entries(this.active_filters[filterGroup]).length
    }

    getSelectedFilters(obj) {
        return Object.keys(obj).map(function (key, index) {
            var out = [];
            for (var i in obj[key]) out.push(obj[key][i]);
            return out.filter(function (item) {
                return item.selected == true;
            });
        });
    }
    /**
     * Actualiza el histórico de filtros
     * @param {*} data
     */
    updateFilterHistory(data) {
        // TODO: implement
        return;

        for (var fh in this.filter_history) {
            var value = this.filter_history[fh];
            var key = Object.keys(value)[0];
            var vl = value[key];
            if (!(typeof (data[key]) === "object" && data[key].indexOf(vl) !== -1)) {
                this.deleteFromHistory(key, vl);
            }
        }
        for (var fh1 in data) {
            if (fh1 !== 'market' && fh1 !== 'language') {
                for (var i in data[fh1]) {
                    this.addToHistory(fh1, data[fh1][i]);
                }
            }
        }
    }

    /**
     * Ordena un array per l'element 'text' de cada child
     *
     * @param {Array} childs
     * @returns {Array}
     */
    orderedText(childs) {
        var sorted = {},
            key, out = [];

        for (key in childs) {
            if (childs.hasOwnProperty(key)) {
                out.push(key);
            }
        }

        out.sort(function (a, b) {
            return (
                childs[a]['text'].capitalize() > childs[b]['text'].capitalize() ?
                    1 :
                    0
            );
        });

        for (key = 0; key < out.length; key++) {
            sorted[out[key]] = childs[out[key]];
        }

        return sorted;
    }

    /**
     * TODO: aquesta funció diria que, donat un element a filtrar, mira si l'ha d'afegir o no i retorna un array amb tots els filtres aplicats
     * @param {*} filter
     * @param {*} component
     * @param {*} orderBy
     * @param {*} saved_query
     * @returns
     */
    getFilters(filter, component, orderBy, saved_query) {
        var App = this
        var x;

        if (orderBy !== undefined & typeof orderBy == 'object') {
            x = {
                'language': App.selected_language,
                'market': App.selected_market_solutions,
                'order_by': orderBy.field,
                'order_by_type': orderBy.direction
            };
        } else {
            x = { 'language': App.selected_language, 'market': App.selected_market_solutions };
        }

        if (saved_query !== undefined) {
            x['id_query'] = saved_query.id;
        }

        for (var keyfamily in this.active_filters) {
            var filterkey = keyfamily;
            if (keyfamily == 'product_families') {
                filterkey = 'products';
            }
            for (var keyfilter in this.active_filters[keyfamily]) {
                if (filter != null && this.active_filters[keyfamily][keyfilter].text == filter.text && component.current_category_filter_selected == keyfamily && filter.selected) {
                    if (x[filterkey] == undefined) {
                        x[filterkey] = [];
                    }
                    x[filterkey].push(keyfilter);
                } else if (this.active_filters[keyfamily][keyfilter].selected == true) {
                    if (x[filterkey] == undefined) {
                        x[filterkey] = [];
                    }
                    x[filterkey].push(keyfilter);
                }
            }
        }
        return x;
    }


    /**
     * Agrupa les solucions per obra
     *
     * @returns Array
     */
    getSolutionsByObra() {
        var solutions = this.active_search

        var solutions_out = {};
        var solutions_out_cnt = 0;

        for (var i = 0; i < solutions.length; i++) {
            if (i > 0 && solutions[i - 1].name == solutions[i].name) {
                solutions_out[solutions_out_cnt - 1].push(solutions[i]);
            } else {
                solutions_out[solutions_out_cnt] = [solutions[i]];
                solutions_out_cnt++;
            }
        }

        return solutions_out;
    }

    /**
     * Ordena un array per l'element 'text' de cada child
     *
     * @param {Array} childs
     * @returns {Array}
     */
    orderSolutiondBy(field, direction) {
        var filters = this.getFilters(null, this, {
            field: field,
            direction: direction
        })

        this.runSolutionsQuery(filters)
    }

    indexForSolutionId(id) {
        for (let index = 0; index < this.active_search.length; index++) {
            const element = this.active_search[index];
            if (element.id == id) {
                return index
            }
        }
        return -1
    }
    nextSolutionId(currentId) {
        var index = this.indexForSolutionId(currentId)

        if (index == -1 || index + 1 == this.active_search.length) {
            // Last
            return null;
        } else {
            return this.active_search[index + 1].id
        }
    }
    prevSolutionId(currentId) {
        var index = this.indexForSolutionId(currentId)

        if (index == 0 || index == -1) {
            return null;
        } else {
            return this.active_search[index - 1].id
        }
    }

    /**
     * Gets a solution data and stores it to App.solution
     * @param {int} id
     * @param {function} on_load
     * @returns
     */
    async getSolution(id) {
        var on_load = function () { };

        var solution = await this.App.api.get(
            "/solution/" + id,
            {
                // Authorization: this.bearer
            });

        // Arreglar productes (treure duplicats, crec...)
        var elements = [];

        solution.products = solution.products.filter(function (element) {
            if (elements.indexOf(element[0] + "_" + element[1]) !== -1) return false;
            elements.push(element[0] + "_" + element[1]);
            return true;
        });

        return solution;

    }

    async getStoredQueries(id_market) {
        var queries = await this.App.api.get(
            "/queries-list?id_market=" + id_market + "&market_query=false"
        )
        console.warn(queries)

        return queries
    }

    async getStoredMarketQueries(id_market, fncError) {
        var queries = await this.App.api.get(
            "/queries-list?id_market=" + id_market + "&market_query=true"
        )
        console.warn(queries)

        return queries
        return []
        // fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        // return this.getRequest(this.url + "/queries-list?id_market=" + id_market + "&market_query=true",
        //     {
        //         // Authorization: this.bearer
        //     }, (function () { }), false, fncError);
    }

    async loadSavedQuery(query){
        this.current_query = query
        await this.runFiltersQuery(query.data)
        // this.active_filters = query.data
        // console.warn(query)

    }

    storeQuery(query_data, fncError) {
        // fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        // return this.postRequest(
        //     this.url + "/queries-store",
        //     query_data,
        //     {
        //         Authorization: this.bearer,
        //         Accept: "application/json",
        //         "Content-Type": "application/json"
        //     },
        //     (function () { }),
        //     false,
        //     fncError);
    }

    deleteQuery(id_query, fncError) {
        // fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });
        // return this.getRequest(this.url + "/query-delete/" + id_query, { Authorization: this.bearer }, (function () { }), false, fncError);
    }
}